import { httpRequest } from "../../http";
import {
  CatalogDimension, DimensionIn, DimensionValue, DimensionValueIn,
} from "@models/catalog.model";

const COLL = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/dimensions/`;

export class CommandCreateDimension {
  async run(payload: DimensionIn): Promise<CatalogDimension> {
    return httpRequest<CatalogDimension>(COLL, { method: "POST", body: payload });
  }
}

export class CommandUpdateDimension {
  async run(id: number, payload: DimensionIn): Promise<CatalogDimension> {
    return httpRequest<CatalogDimension>(`${COLL}${id}/`, { method: "PUT", body: payload });
  }
}

export class CommandDeleteDimension {
  async run(id: number): Promise<void> {
    await httpRequest(`${COLL}${id}/`, { method: "DELETE" });
  }
}

// Dimension values are the curated list an axis folds its messy encodings onto (MPN-1278).
// Nested under their dimension because that is the only place they mean anything.
const values = (dimensionId: number) => `${COLL}${dimensionId}/values/`;

export class CommandListDimensionValues {
  async run(dimensionId: number): Promise<DimensionValue[]> {
    return httpRequest<DimensionValue[]>(values(dimensionId));
  }
}

export class CommandCreateDimensionValue {
  async run(dimensionId: number, payload: DimensionValueIn): Promise<DimensionValue> {
    return httpRequest<DimensionValue>(values(dimensionId), { method: "POST", body: payload });
  }
}

export class CommandUpdateDimensionValue {
  async run(dimensionId: number, id: number, payload: DimensionValueIn): Promise<DimensionValue> {
    return httpRequest<DimensionValue>(`${values(dimensionId)}${id}/`, {
      method: "PUT", body: payload,
    });
  }
}

export class CommandDeleteDimensionValue {
  async run(dimensionId: number, id: number): Promise<void> {
    await httpRequest(`${values(dimensionId)}${id}/`, { method: "DELETE" });
  }
}
